import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Quilleditor } from "../../Quilleditor/Quilleditor";
import RangeSilder from "../../RangeSilder/RangeSilder";
import Data from "../../../translations/en/common.json";
import EditorInput from "../../Inputs/EditorInput";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";

function LanguageItem(props) {
  const [t, i18n] = useTranslation("common");

  return (
    <div className="row px-3">
      <div className="col-md-12 mb-3 mr-2">
        {!props.showPopup && (
          <img
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
            alt="trash"
            className="ml-1 delete_icon float-right"
            onClick={props.handleItemDelete}
          />
        )}
      </div>
      <div className="col-md-6 mb-3">
        <EditorInput
          label={t(`languages.name`)}
          value={props.res.name}
          name="name"
          autoComplete="off"
          className={`form-control  ${props.sectionId}focus${props.index}`}
          onChange={props.resumeHandler}
          onBlur={props.resumeUpdate}
        />
        {/* <label>{t(`languages.name`)}</label>
                        <img
                          src="/images/trash.svg"
                          alt="trash"
                          className="ml-1"
                          onClick={props.handleDelete}
                        />
                        <input
                          type="text"
                          name="name"
                          className={`form-control customform ${props.sectionId}focus${props.index}`}
                          value={props.res.name}
                          onChange={props.resumeHandler}
                        /> */}
      </div>

      <div className="col-md-6 ">
        <label>{t(`languages.level`)}</label>

        <select
          name="level"
          style={{ height: "30px", borderRadius: "6px" }}
          className="form-control customform basic-lang-select level"
          onChange={props.resumeHandler}
          value={props.res.level}
          onBlur={props.resumeUpdate}
        >
          {Data &&
            Data.proficiency &&
            Data.proficiency.map((language, index) => (
              <option value={language.percent}>{language.label}</option>
            ))}
        </select>
      </div>
      <hr />
      {/* <div
        className={
          props.showPopup ? " col-md-12 mb-1  d-flex" : " col-md-12  d-flex"
        }
      >
        {props.saveIndex == props.index ? (
          <ResumeButton success alt="plus" title="Save" />
        ) : (

          <ResumeButton
            success
            alt="plus"
            title="Save"
            className="mr-2"
            onClick={() => {
              props.resumeUpdate();
              props.setSaveIndex();
            }}
          />

        )}
        <ResumeButton
          white
          alt="plus"
          title="Cancel"
          onClick={props.resumeUpdateCancel}
        />

      </div> */}
    </div>
  );
}

export default LanguageItem;
